import * as React from 'react';
import { useChatInputToken_unstable } from './useChatInputToken';
import { renderChatInputToken_unstable } from './renderChatInputToken';
import { useChatInputTokenStyles_unstable } from './useChatInputTokenStyles.styles';
import type { ChatInputTokenProps } from './ChatInputToken.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// ChatInputToken component
export const ChatInputToken: ForwardRefComponent<ChatInputTokenProps> = React.forwardRef((props, ref) => {
  const state = useChatInputToken_unstable(props, ref);

  useChatInputTokenStyles_unstable(state);
  return renderChatInputToken_unstable(state);
});

ChatInputToken.displayName = 'ChatInputToken';
